import { COLORS } from '@btime/constants'
import { capitalizeAllIfLower, formatDate } from '@btime/helpers'
import { compose, prop } from 'ramda'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { Col, Grid } from '../../../packages/kiti/components/structure/Grid'
import { RefetchingIndicator } from '../../../components/helpers/StatePresenter'
import { SmallText, Title } from '../../../packages/kiti/components/presentation/Text'
import { useAsset } from './_load/AssetLoader'
import DeletedTag from '../../../components/helpers/DeletedTag'
import { useAssetActions } from '../_actions/assetActions'
import DropdownLink from '../../../components/navigation/DropdownLink'
import Icon from '../../../components/shapes/Icon'
import TabsMenu from '../../../packages/kiti/components/tabs/TabsMenu'

const ModalHeader = () => {
  const { t } = useTranslation()
  const asset = useAsset()
  const [options] = useAssetActions(asset, null, { hide: ['seeDetails'] })

  const title = compose(capitalizeAllIfLower, prop('name'))(asset)
  const createdAt = compose(formatDate('DD/MM/YYYY HH:mm'), prop('insertedAt'))(asset)

  return (
    <>
      <Grid justify="flex-start" align="center" gutter={0.3}>
        <Col flex={1}>
          <Title size="h4" color={COLORS.dark2} noMargin>
            {title}
          </Title>
          <SmallText color={COLORS.dark3}>
            {t('createdAt')} {createdAt}
          </SmallText>
        </Col>

        <Col flex={1}></Col>

        <Col>
          <DeletedTag entity={asset} />
        </Col>
        <Col>
          <RefetchingIndicator />
        </Col>
        {!asset.deleted && (
          <Col>
            <DropdownLink
              fromRight
              options={options}
              actionContent={<Icon name="BsThreeDotsVertical" size={1.4} />}
              t={t}
            />
          </Col>
        )}
      </Grid>
      <TabsMenu t={t} />
    </>
  )
}

export default ModalHeader
